<template>
  <div class="row advisor-search-page-zip no-gutters" role="tabpanel" id="advisor-search-by-location"
    aria-labelledby="advisor-search-page-tab_by_location">
    <div class="advisor-dropdown col-12 col-sm-12 col-md-5 col-lg-5" v-if="!isWealthAdvisorSearch"
      @click="showTypeFilter = !showTypeFilter">
      <button class="pill large" type="button" @click="showTypeDropdown = !showTypeDropdown" id="advisor-type"
        :aria-expanded="showTypeDropdown ? 'true' : 'false'" aria-controls="advisor-select">
        <span class="sr-only">Select</span>{{ typePlaceholder }}
        <span class="caret"></span>
      </button>
      <fieldset class="selection showselect" id='advisor-select' v-if="showTypeDropdown"
        v-click-outside="{ 'method': hideTypeDropdown, 'except': ['advisor-select', 'advisor-type'] }">
        <legend class="sr-only">
          Advisors Filter
        </legend>
        <div class="col-12 selection__radio" v-for="(filterOption) in typeFilterOptions" :key="filterOption">
          <input :id="filterOption" type="radio" name="advisor-type-select" v-model="type" v-bind:value="filterOption"
            @keyup.space="showTypeDropdown = false;" />
          <label :for="filterOption" @click="triggerAdvisorFilter(filterOption)"><span class="checkmark fas fa-check"
              aria-hidden="true"></span>{{ filterOption }}</label>
        </div>
      </fieldset>
    </div>
    <div
      v-bind:class="{ 'advisor-zip col-12': true, 'col-sm-12 col-md-10 col-lg-10': isWealthAdvisorSearch, 'col-sm-12 col-md-6 col-lg-6': !isWealthAdvisorSearch }">
      <div class="advisor-zip-wrap floating-label" v-bind:class="{ 'has-focus is-floating': focused }">
        <span class="pill large">
          <label class="search-location-label">{{ placeholder }}</label>
          <gmap-autocomplete ref="place" type="search" :select-first-on-enter="true" @place_changed="submitByEnter"
            aria-label="Search" class="pac-target-input" placeholder="" aria-autocomplete="list"
            v-bind:aria-describedby="showError ? 'error-search-by-location' : 'advisors-search-by-location-autocomplete'"
            v-on:focus="focused = true" v-on:blur="handleBlur" :options="{
      bounds: { north: 39.4, south: 31.4, east: -82.4, west: -99.8 },
      strictBounds: false,
      componentRestrictions: { country: 'us' }
    }" />
        </span>
        <p class="text-danger d-block d-lg-none" id="error-search-by-location" v-if="showError">{{
      text("advisorSearchByTypeError") }}</p>

        <div class="advisor-zip-text-wrap">
          <a href="javascript:;" v-on:click="nearMe">{{ text("findMyLocation") }}</a>
        </div>
      </div>
      <p class="text-danger d-none d-lg-block" id="error-search-by-location" v-if="showError">{{
      text("advisorSearchByTypeError") }}</p>
      <p class="sr-only" id="advisors-search-by-location-autocomplete">Search results will populate as you type. Use the
        arrow keys to navigate and choose a result.</p>
    </div>
    <div class="location-submit-button col-12 col-sm-12 col-md-1 col-lg-1">
      <button class="btn btn-primary" @click="submitByClick">{{ text("advisorSearchByTypeCTA") }}</button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import EventBus from "../functions/eventBus";
  import * as VueGoogleMaps from "vue2-google-maps";
  import { locText } from "../../../utils/useText";
  import { capitalizeString } from "../../../utils/functions";
  import { formatAddress } from '../../../location-search/src/functions/results';
  import { gmapApi } from 'vue2-google-maps';
import parseAddress from '../functions/parseAddress';

  export default {
    data() {
      return {
        searchTerm: null,
        showError: false,
        showTypeFilter: false,
        type: null,
        showTypeDropdown: false,
        focused: false,
        directConsumer: false,
      presetTypeData: '',
      newStateArray: ['AR', 'KS', 'MO', 'OK', 'TN', 'TX', 'MS', 'Texas', 'Arkansas', 'Missouri', 'Kansas', 'Oklahoma', 'Tennessee', 'Mississippi']
      };
    },
    created() {

      var uri = window.location.search.substring(1);
      var params = new URLSearchParams(uri);
      var initType = params.get("advisortype");
    this.presetTypeData = this.presetType
    if (initType) {
      this.type = this.userType = this.presetTypeData = initType;
      }
      this.getTypeFilterOptions();
    if (this.presetTypeData) {
      this.type = this.userType = this.presetTypeData;
    } 
  },
  mounted() {
    //if local storage has zip - geolocate by zip
    //else trigger nearMe search by default.
    var zipCode = this.zipCodeFromLocalStorage;

    if (!zipCode) {
      this.nearMe();
    } else {
      this.searchByZipCode(zipCode)
    }
    },
    components: {
      "gmap-autocomplete": VueGoogleMaps.Autocomplete
    },
    computed: {
      isWealthAdvisorSearch() {
      return this.presetTypeData == "Wealth Advisor";
      },
      google: gmapApi,
      placeholder() {
        return this.current ? this.searchTerm : this.text("advisorsPlaceholder");
      },
      typeFilterOptions() {
        return this.$store.getters.typeFilterOptions;
      },
      typePlaceholder: {
        get() {
          return this.type
            ? capitalizeString(this.type)
            : this.text("advisorTypePlaceholder");
        }
      },
      userSearchLocation: {
        get() {
          return this.$store.getters.userSearchLocation;
        },
        set(value) {
          this.updateUserSearchLocation(value);
        }
      },
      newConsumerDirect: {
        get() {
          return this.$store.getters.newConsumerDirect;
        },
        set(value) {
          this.updateNewConsumerDirect(value);
        }
      },
      isDirectConsumer: {
        get() {
        return this.$store.getters.isDirectConsumer;
        },
        set(value) {
        this.updateDirectConsumer(value);
        }
      },
      userType: {
        get() {
          return this.$store.getters.userType;
        },
        set(value) {
          this.updateUserType(value);
        }
    },
    zipCodeFromLocalStorage: {
      get() {
        return window.localStorage.getItem('userZip');
      },
      set(value) {
        window.localStorage.setItem('userZip', value);
      }
      }
    },
    methods: {
      ...mapActions([
        "geolocateUser",
        "getTypeFilterOptions",
        "updateAdvisors",
        "updateUserSearchLocation",
        "updateUserType",
        "updateAdvisorsWithConsumer",
        "updateDirectConsumer",
      "updateNewConsumerDirect",
      "resetCurrentPage",
      "updateFilters"
      ]),
      async nearMe() {
        this.showError = false;
        this.userType = this.type;
        this.$refs.place.$el.value = "";
        this.hideTypeDropdown();

        if (typeof HERO_analytics_data_layer != "undefined") {
          let analytics = HERO_analytics_data_layer,
            event = {
            event: "search",
            search__type: this.tabTitle,
            search__term: "Find by current location"
          };
        if (this.type) {
          event.search__advisor_type = this.type;
        }
        analytics.pushEventAndData(event);
      }

        navigator.geolocation.getCurrentPosition(
          position => {
            // if it is iPhone and user hits accept I use the Browser lat and long
            var _ = this;
            _.$gmapApiPromiseLazy().then(() => {

              let geocoder = new _.google.maps.Geocoder();
              let latLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };

              geocoder.geocode({ 'latLng': latLng }, (results, status) => {
                if (status == _.google.maps.GeocoderStatus.OK) {

                  let formattedAddress = results[0].formatted_address;

                  this.checkStateForDirectConsumer(formattedAddress, latLng);
                  this.showError = false;

                this.$refs.place.$refs.input.value = results[0].formatted_address; // parseAddress(results, 'postal_code');
                this.focused = true;

                  return results

                } else {
                  console.error("Request failed.")
                  this.errored = false
                }
              });
            });
          },
          error => {
            console.log(error.message)
          }
        )

      //this.geolocateUser();
      },
      triggerAdvisorFilter(value) {
        this.showTypeDropdown = false;
        this.type = value;
      const payload = {
        type: this.type
      };

      this.updateFilters(payload);
      },
      hideTypeDropdown() {
        this.showTypeDropdown = false;
      },
    searchByZipCode(zipCode) {
      this.userType = this.type;
      var _ = this;
      this.$refs.place.$refs.input.value = zipCode;
      this.$refs.place.$refs.input.focus();
      this.$refs.place.$refs.input.blur();
      this.focused = true;

      if (typeof HERO_analytics_data_layer != "undefined") {
        let analytics = HERO_analytics_data_layer,
          event = {
            event: "search",
            search__type: this.tabTitle,
            search__term: "Find by postal code"
          };
        if (this.type) {
          event.search__advisor_type = this.type;
        }
        analytics.pushEventAndData(event);
      }

      this.$gmapApiPromiseLazy().then(() => {
        let geocoder = new _.google.maps.Geocoder();
        geocoder.geocode({ 'address': 'zipcode ' + zipCode }, (results, status) => {
          this.loading = true
          if (status == _.google.maps.GeocoderStatus.OK) {

            this.loading = false
            var place = results[0];

            this.zipCodeFromLocalStorage = parseAddress(results, "postal_code")
            if (place && place.geometry && place.formatted_address) {
              let formattedAddress = place.formatted_address;
              if (typeof HERO_analytics_data_layer != "undefined") {
                let analytics = HERO_analytics_data_layer,
                  searchTerm = place.formatted_address,
                  event = {
                    event: "search",
                    search__type: this.tabTitle,
                    search__term: searchTerm
                  };
                if (this.type) {
                  event.search__advisor_type = this.type;
                }
                analytics.pushEventAndData(event);
              }
              const payload = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              };
              // provide state the locations data from input field


              this.checkStateForDirectConsumer(formattedAddress, payload);

            } else {
              this.userSearchLocation = {};
              this.newConsumerDirect = [];
              this.showError = true;
            }
          }
        });
      });
    },
      submitByClick() {
        this.showError = false;
      this.resetCurrentPage();
        this.hideTypeDropdown();

        const el = this.$refs.place.$refs.input;
        if (el.value) {
          this.submitByEnter();
        } else if (
          this.userSearchLocation &&
          this.userSearchLocation.lat &&
          this.userSearchLocation.lng
        ) {
          this.nearMe();
        } else {
          this.showError = true;
          el.focus();
        }
      },
      submitByEnter() {
      this.resetCurrentPage();
        this.showError = false;
        this.hideTypeDropdown();

        let place = this.$refs.place.$autocomplete.getPlace();



      this.userType = this.type;

        if (place && place.geometry && place.formatted_address) {
        this.zipCodeFromLocalStorage = parseAddress([place], "postal_code")
          let formattedAddress = place.formatted_address;
          if (typeof HERO_analytics_data_layer != "undefined") {
            let analytics = HERO_analytics_data_layer,
              searchTerm = place.formatted_address,
              event = {
              event: "search",
              search__type: this.tabTitle,
              search__term: searchTerm
            };
          if (this.type) {
            event.search__advisor_type = this.type;
          }
          analytics.pushEventAndData(event);
          }
          const payload = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
          // provide state the locations data from input field


          this.checkStateForDirectConsumer(formattedAddress, payload);

      } else {
        var el = this.$refs.place.$refs.input;
        if (el.value) {
          this.searchByZipCode(el.value);
          return;
        }

        this.userSearchLocation = {};
        this.newConsumerDirect = [];
        this.showError = true;
      }
    },
    handleBlur() {
      let inputVal = document.querySelector('.pac-target-input').value;
      if (inputVal) {
        this.focused = true;
      } else {
        this.focused = false;
      }
    },
    async checkStateArray(state, payload) {
      const stateArray = this.newStateArray;
      this.loading = true;
      if (stateArray.some(function (v) { return state.indexOf(v) >= 0; })) {
        this.isDirectConsumer = false;
        this.userSearchLocation = payload;
      } else {
        this.updateAdvisorsWithConsumer();
      }
      },
      async checkStateForDirectConsumer(formattedAddress, payload) {
      if (formattedAddress.indexOf(' ')) {
          var firstSplitArray = formattedAddress.split(', ');
        } else {
          var firstSplitArray = formattedAddress.split(',');
        }
        // check if any array item has a space in there will indicate there is a state.
      if (firstSplitArray.length > 2) {
        // checks for an abbreviated state with a space next to it?
        if (firstSplitArray[1].indexOf(' ') >= 0 || firstSplitArray[2].indexOf(' ') >= 0) {
            let state = firstSplitArray[1].split(' ')[0];
            let stateOneComma = firstSplitArray[2].split(' ')[0];

            // check if the state returned is 2 characters, if not, the address is longer and needs to be split in a diff spot
          if (state.length !== 2) {

              // check if the returned stated matches the state array
              this.checkStateArray(stateOneComma, payload);
            } else {
              this.checkStateArray(state, payload);
            }
          } else {
            let stateNoZip = firstSplitArray[1];
            // if the formattedAddress does not have a zip code in it
            this.checkStateArray(stateNoZip, payload);
          }

        } else {
          let stateFull = firstSplitArray[0];
          this.checkStateArray(stateFull, payload);
        }
      }

  },
  mixins: [locText],
  props: {
    presetType: String,
    tabTitle: String
  },
  watch: {

      userSearchLocation(newValue) {
        let payload = {
          lat: newValue.lat,
          lng: newValue.lng,
          radius: this.$store.getters.userDistance
        };

      if (this.presetTypeData == "Wealth Advisor") {
          payload = {
            ...payload,
            wealth: true
          };
        }
        // call function to get new advisor data
        this.updateAdvisors(payload); 
      }
    }
  };
</script>
